/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { styled } from "@mui/material";
import { Button, Chip, Select, Typography } from "@mui/material";

export const StyledPickerContainer = styled('div')({
  marginBottom: '12px',
})

export const StyledPickerLabel = styled(Typography)({
  display: 'flex',
  alignItems: 'center',
  fontSize: '13px',
  fontWeight: '500',
  color: '#3c3c3c',
  marginBottom: '4px',
})

export const StyledProfileSelect = styled(Select)({
  fontSize: '13px',
  backgroundColor: '#fff',
  '& .MuiSelect-select': {
    padding: '8px 10px',
  },
})

export const StyledSelectPlaceholder = styled('span')({
  fontSize: '13px',
  color: '#8a8a8a',
})

export const StyledSelectedProfile = styled('span')({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '6px',
  fontSize: '13px',
  color: '#3c3c3c',
})

export const StyledInactiveTag = styled(Chip)({
  height: '17px',
  flexShrink: 0,
  fontSize: '10px',
  fontWeight: '600',
  letterSpacing: '0.3px',
  textTransform: 'uppercase',
  backgroundColor: '#eef2f7',
  color: '#5a6b80',
  '& .MuiChip-label': {
    padding: '0px 5px',
  },
})

export const StyledPickerHelperText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'tone',
})(({ tone }) => ({
  fontSize: '12px',
  fontWeight: '400',
  marginTop: '4px',
  color: tone === 'warning' ? '#a45b00' : '#6b6b6b',
}))

export const StyledRetryButton = styled(Button)({
  minWidth: 'auto',
  padding: '2px 6px',
  fontSize: '12px',
  fontWeight: '500',
  textTransform: 'none',
  color: '#1976d2',
})

export const profileMenuProps = {
  PaperProps: { sx: { maxHeight: '40vh', width: '320px' } },
  autoFocus: false,
}
